module.exports = __webpack_public_path__ + "media/images/icons/arrow-up-blue-9bb101067cd50d663e848901ccc262ab.svg";